import {Controller} from "@hotwired/stimulus"

// Narrows an already-rendered list by the text its items contain. For lists that
// are long enough to scroll but short enough to send whole — a customer's saved
// addresses, where a round trip per keystroke would cost more than the markup.
//
// Matching is on textContent, so whatever the item shows is what it is searched by.
export default class extends Controller {
    static targets = ["input", "item", "empty"]

    filter() {
        const query = this.inputTarget.value.trim().toLowerCase()
        let shown = 0

        this.itemTargets.forEach((item) => {
            const matches = query === "" || item.textContent.toLowerCase().includes(query)
            item.classList.toggle("ice:hidden", !matches)
            if (matches) shown += 1
        })

        if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("ice:hidden", shown > 0)
    }

    clear(event) {
        if (event.key !== "Escape") return

        // Escape inside the field clears it rather than closing the modal around it:
        // losing a half-typed search should not lose the dialog too.
        event.stopPropagation()
        this.inputTarget.value = ""
        this.filter()
    }
}
